import angular from 'angular'
import uiRouter from '@uirouter/angularjs'

export default angular.module('app.sesion', [
  uiRouter,
])



// WEBPACK FOOTER //
// ./src/app/sesion/module.js